import axiosInstance from "./axiosInstance";

class HTTPSCalls {
  static EndPoints = {
    GET_USER: "/user/get",
    ADD_VESSEL: "/vessels/add",
    ADD_CONTACTSUPPORT: "/support-requests/store",
    GET_VESSEL_USERID: "/vessels/get",
    UPDATE_VESSEL_DETAILS: "/vessels/update/{id}/detail",
    GET_PLAN: "/user/subscriptions",
    USER_UPDATE_PASSWORD: "/user/update/password",
    UPDATE_USER: "/user/update/profile",
    UPDATE_PASSWORD: "/user/update/password",
    GET_NOTIFICATION: "/user/notification-settings/get",
    UPDATE_NOTIFICATION: "/user/notification-settings/store-or-update",
    DELETE_VESSEL_FILE: "/vessels/delete/{id}/file",
    UPDATE_VESSEL_FILE: "/vessels/update/{id}/file",
    GET_COUPONS: "/user/coupons",
    GET_SIGNUP_COUPON: "/signup/promotion/get",
    SUBSCRIPTIONPREMIUM: "/user/subscription-store",
    END_SUBSCRIPTION: "/user/subscription-cancel/{id}",
    WEB_CONTENT: "/website-settings/get",
    UPDATE_DELIVERY: "/vessels/update-at-delivery/{id}",
    DELIVERY_REQUEST: "/vessels/delivery-request",
    DELETE_VESSEL_FIELDS: "/delete-fields/{id}",
    USER_GET_BY_ROLE: "/user/get-by-role/{role}",
    JOB_POST_FORM: "/user/job-post/{id}",
    DROPDOWNS_ADDVESSEL: "/vessels/form/data",
    GET_JOB_CARD: "/user/job-posts",
    GET_DELIVERY_CARD: "/vessels/delivery/requests",
    ABOUT_US_SPCIFICS: "/user/fetch/job-post",
    FORGOT_PASSWORD: "/forgot/password",
    DELIVERY_PAYMENT: "/user/payment/delivery-payment",
    SUMSUB_VERIFY_STATUS: "/user/sumsub-verify-status",
    RESET_PASSWORD: "/reset/password",
    GET_FEEDBACK_USER: "/feedback/fetch/delivery-users",
    HAS_SUBMITTED_FEEDBACK: "/feedback/has-submitted",
    FEEDBACK_BACK: "/feedback/delivery-form",
    DELIVERY_USER: "/vessels/delivery/skipper",
    FETCH_VESSEL_FOR_DELIVRY: "/vessels/get/delivery",
    DELIVERY_REQUEST_TRACKING: "/vessels/delivery-request/tracking/{id}",
    GET_DELIVERY_REQUEST_TRACKING:
      "/vessels/delivery-request/tracking/get/{id}",
    DELETE_DELIVERY_REQUEST_TRACKING:
      "/vessels/delivery-request/tracking/delete/{id}",
    // EXPERIENCE_ADD: "/user/experience/add",
    // EXPERIENCE_UPDATE: "/user/experience/update/{id}",
    // EXPERIENCE_GET: "/user/experience/get",
    UPDATE_SKIPPER_CHECKIN_STATUS:
      "/vessels/delivery-request/tracking/update-status/{id}",
    GE_VESSEL_NAME_CHECKIN_CHECKOUT_STATUS: "/vessels/get-by-delivery/{id}",
    UPLOAD_REG_DOCUMENT_CHECKING:
      "/vessels/delivery-request/tracking/documents/{id}",
    DELETE_REG_DECUMENT_CHECKING:
      "/vessels/delivery-request/tracking/delete-documents/{id}",
    SKILL_ADD: "/user/skills/add",
    SKILL_GET: "/user/skills/get",
    SKILL_UPDATE: "/user/skills/update/{id}",
    SKILL_DELETE: "/user/skills/delete/{id}",
    JOURNEY_ADD: "/user/journey/add",
    JOURNEY_GET: "/user/journey/get",
    JOURNEY_UPDATE: "/user/journey/update/{id}",
    ADD_PERSONAL_DETAILS: "/user/personal-log/addOrUpdate/{id?}",
    GET_PERSONAL_DETAILS: "/user/personal-log/get",
    PERSONAL_DETAILS_DELETE: "/user/personal-log/delete/{id}",
    UPDATE_BACKGROUND_BANNER: "/user/update/background-image",
    REMOVE_BACKGROUND_BANNER: "/user/remove/background-image",
    ADD_DELIVERY_EXPENCES: "/vessels/delivery-expenses/store",
    GET_DELIVERY_EXPENCES: "/vessels/delivery-expenses/get",
    ADD_DELIVERY_INCIDENTS: "/vessels/delivery-incidents/store",
    GET_DELIVERY_INCIDENTS: "/vessels/delivery-incidents/get",
    ACTIVE_DELIVERY_REQUEST: "/user/active/delivery-requests",
    ADD_USER_REVIEW: "/user/reviews/add",
    GET_USER_REVIEW: "/user/reviews/get/{revieweeId}",
    UPDATE_USER_REVIEW: '/user/reviews/update/{id}',
    DELETE_USER_REVIEW: "/user/reviews/delete/{id}",
    ADD_CREW_JOB: "/user/crew/add-job-post",
    GET_CREW_JOB: "/user/crew/job-posts",
    GET_CREW_PROFILE_BY_ID: "/user/crew/job-post/{id}",
    USER_POSTS: "/user/post",
    ArchiveVessel: "/vessels/archive/{id}",
    UNARCHIVEVESSEL: '/vessels/restore/{id}',
    GET_Archived_Vessels: "/vessels/get/archive",
    DeleteVessel: "/vessels/delete/{id}",
    ADD_Qualification: "/user/qualifications/add",
    GET_QUALIFICATION: "/user/qualifications/get",
    DELETE_QUALIFICATION: "/user/qualifications/delete/{id}",
    UPDATE_QUALIFICATION: "/user/qualifications/update/{id}",
    SEARCH_QUALIFICATION: "/user/qualifications/search",
    ACTIVE_DELIVERY_CREW: "/user/active/delivery-requests",
    ADD_INCIDENT: "/user/incident-report/store",
    CANCEL_DELIVERY: "/vessels/cancel/delivery-request/{id}",
    ADD_DELIVERY_CREW: "/user/crew/delivery-crews",
    GET_DELIVERY_CREW: "/user/crew/get-by-delivery/{id}",
    ADD_TO_SHORTLIST: "/user/shortlist/job-post",
    GET_DELIVERY_CREW_LIST: "/user/crew/get/delivery-crews",
    SHORT_LISTED_JOB_POSTS: "/user/shortlisted/job-posts",
    REMOVE_SHORTLISTED_JOB_POSTS: "/user/remove/shortlist/job-post",
    ADD_Experience: "/user/experience/add",
    GET_EXPERIENCE: "/user/experience/get",
    UPDATE_EXPERIENCE: "/user/experience/update/{id}",
    DELETE_EXPERIENCE: "/user/experience/delete/{id}",
    PLAN_DETAILS: "/user/subscription-get",
    ADD_HEADLINE: "/user/headline",
    JOB_POST_WITH_DELIVERY_ID: "/user/get/job-post/by-deliveryId",
    SIGNWELL_DOCUMENT: "/vessels/get/signed-doc",
    START_CHECKOUT_signwell: "/signwell/start-checkout-signing",
    REMAINING_PAYMENT: "/user/payment/remaining-delivery-payment",
    REMAINING_PAYMENT: "/user/payment/remaining-delivery-payment",
    ADD_INTERESTS_HOBBIES: "/user/hobbies-interests/add",
    UPDATE_INTERESTS_HOBBIES: "/user/hobbies-interests/update/{id}",
    GET_INTERESTS_HOBBIES: "/user/hobbies-interests/get",
    DELETE_INTERESTS_HOBBIES: "/user/hobbies-interests/delete/{id}",
    ADD_AWARD_HONORS: "/user/awards/add",
    UPDATE_AWARD_HONORS: "/user/awards/update/{id}",
    GET_AWARD_HONORS: "/user/awards/get",
    GET_MY_PERSONAL_INFO: "/user/get/my-personal-info",
    DELETE_AWARD_HONORS: "/user/awards/delete/{id}",
    GET_VESSEL_BY_ID: "/vessels/get-by-id/{id}",
    DELIVERY_COMPLETED: "/vessels/delivery-completed/{id}",
    PASSAGE_IMAGES: "/vessels/delivery-request/passage",
    PASSAGE_IMAGES_GET: "/vessels/delivery-request/passage/get/{id}",
    CANCEL_QUOTE: "/user/skipper/cancel-quote",
    SEARCH_MANUFACTURING: "/vessels/search/manufacturing",
    UPDATE_EVENT_CALENDAR: "/user/skipper/update-calendar/{id}",
    DELETE_EVENT_CALENDAR: "/user/skipper/delete-calendar/{id}"
  };

  static GET = async (URL_BASE, URLParameters = {}, headers = {}) => {
    return await axiosInstance.get(
      URL_BASE + new URLSearchParams({ ...URLParameters }).toString(),
      { headers }
    );
  };

  static POST = async (
    URL_BASE,
    URLParameters = {},
    requestBody,
    headers = {}
  ) => {
    return await axiosInstance.post(
      URL_BASE + new URLSearchParams({ ...URLParameters }).toString(),
      requestBody,
      { headers }
    );
  };

  static POST_FROM = async (URL_BASE, URLParameters = {}, requestBody) => {
    return await axiosInstance.postForm(
      URL_BASE + new URLSearchParams({ ...URLParameters }).toString(),
      requestBody
    );
  };

  static DELETE = async (URL_BASE, URLParameters = {}, headers = {}) => {
    return await axiosInstance.delete(
      URL_BASE + new URLSearchParams({ ...URLParameters }).toString(),
      { headers }
    );
  };
}

export default HTTPSCalls;
